import React from 'react';
import HeaderTags from '../../common/headerTags/HeaderTags';
import AnuncieConoscoComponent from '../../components/anuncieConosco/AnuncieConoscoComponent';

const headerTags = {
    title: 'Anuncie Conosco - na maior rede de rádios do Brasil', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta: {
        description: 'Saiba as vantagens e como anunciar na maior rede de rádios voltado para o publico adulto qualificado do Brasil. Acesse o nosso portal exclusivo de vendas ou fale conosco por telefone ou WhatsApp ou manda uma mensagem!',
        keywords: 'anuncie conosco, anunciar na rádio, maior rede de rádios, público adulto, público qualificado, rádios do Brasil, commercial, publicidade, entrar em contato, telefone, whatsapp, informações',
        'og:title': 'Anuncie Conosco - Anuncie na maior rede de rádios voltado para o público adulto qualificado do Brasil',
        'og:description': 'Saiba as vantagens e como anunciar na maior rede de rádios voltado para o publico adulto qualificado do Brasil. Acesse o nosso portal exclusivo de vendas ou fale conosco por telefone ou WhatsApp ou manda uma mensagem!',
        'og:image': 'https://a1media.antena1.com.br/image/share/anuncie-conosco.png',
    },
};


const AnuncieConosco = () => (
    <div className="pageWrapper">
        <HeaderTags title={headerTags.title} meta={headerTags.meta} />
        <AnuncieConoscoComponent />
    </div>
);

export default AnuncieConosco;
